export const FARMS_SET_FARMS = "FARMS_SET_FARMS";
export const FARMS_SET_LOADER = "FARMS_SET_LOADER";
export const FARMS_SET_SHOWALL = "FARMS_SET_SHOWALL";
export const FARM_SET_FARM = "FARM_SET_FARM";
export const FARM_RESET = "FARM_RESET";
export const FARMS_SET_NOTIFICATION = "FARMS_SET_NOTIFICATION";
export const FARMS_RESET_NOTIFICATION = "FARMS_RESET_NOTIFICATION";
